import _get from 'lodash/get';

export interface SelectedDocValue {
  value: string;
  label: string;
}

export default function getSelectedDocValues(
  currentOptions: Record<string, unknown>[],
): SelectedDocValue[] {
  return currentOptions
    .filter((opt) => _get(opt, 'optionDocumentation.documentationId'))
    .map((opt) => ({
      value: _get(opt, 'optionDocumentation.documentationId') as string,
      label: _get(opt, 'optionDocumentation.documentationId') as string,
    }));
}
